import { createFileRoute } from '@tanstack/react-router'
import { HeroSection } from '@/features/landing/components/HeroSection'
import { CapabilitiesSection } from '@/features/landing/components/CapabilitiesSection'
import { FeaturesSection } from '@/features/landing/components/FeaturesSection'
import { ClaimsSection } from '@/features/landing/components/ClaimsSection'
import { ComparisonSection } from '@/features/landing/components/ComparisonSection'
import { PricingSection } from '@/features/landing/components/PricingSection'
import { FAQSection } from '@/features/landing/components/FAQSection'
import { LandingFooter } from '@/features/landing/components/LandingFooter'

export const Route = createFileRoute('/_public/')({
  component: MarketingLandingPage,
})

function MarketingLandingPage() {
  return (
    <>
      <HeroSection />
      <CapabilitiesSection />
      <FeaturesSection />
      <ClaimsSection />
      <ComparisonSection />
      <PricingSection />
      <FAQSection />
      <LandingFooter />
    </>
  )
}
